// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"23675e29","120":"8d5d3b33","230":"91b77f7c","289":"d5b418aa","381":"01708ad1","407":"8ccafb27","584":"294d4e90","616":"6b39bfcb","688":"0cc104ed","877":"b35a3114","981":"2154498a"}[chunkId] + ".chunk.js";
};